import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArchiveRestore, Archive, ExternalLink } from "lucide-react";
import { toast } from "sonner";

export default function InstellingenGearchiveerd() {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/organisaties", { params: { gearchiveerd: true } });
      setOrgs(data || []);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const activeer = async (o) => {
    await api.patch(`/organisaties/${o.id}`, { gearchiveerd: false, actief: true });
    toast.success(`${o.naam} weer op actief gezet`);
    setOrgs((x) => x.filter((i) => i.id !== o.id));
  };

  return (
    <div className="space-y-6 max-w-3xl" data-testid="instellingen-gearchiveerd">
      <div>
        <h1 className="font-display text-3xl font-medium flex items-center gap-2">
          <Archive className="h-6 w-6 text-primary" /> Gearchiveerde relaties
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          Op non-actief gezette relaties. Zet ze hier weer op actief om ze opnieuw in de relatielijst te tonen.
        </p>
      </div>

      <div className="bg-card border border-border rounded-xl divide-y divide-border" data-testid="gearchiveerd-lijst">
        {loading && <div className="p-6 text-sm text-muted-foreground">Laden…</div>}
        {!loading && orgs.length === 0 && (
          <div className="p-8 text-center text-sm text-muted-foreground">Geen gearchiveerde relaties.</div>
        )}
        {orgs.map((o) => (
          <div key={o.id} className="flex items-center gap-3 p-4" data-testid={`gearchiveerd-row-${o.id}`}>
            <div className="flex-1 min-w-0">
              <div className="font-medium truncate flex items-center gap-2">
                {o.naam}
                <Badge variant="outline" className="capitalize text-xs">{o.status}</Badge>
              </div>
              <div className="text-xs text-muted-foreground truncate">
                {[o.plaats, o.email, o.klantgroep].filter(Boolean).join(" · ")}
              </div>
            </div>
            <Link to={`/organisaties/${o.id}`} className="text-muted-foreground hover:text-foreground" title="Openen">
              <ExternalLink className="h-4 w-4" />
            </Link>
            <Button size="sm" variant="outline" onClick={() => activeer(o)} data-testid={`activeer-${o.id}`}>
              <ArchiveRestore className="h-4 w-4 mr-1" /> Activeren
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
